export default __webpack_public_path__ + "static/media/JalapenoPoppers.c1d1a265.jpg";